import React from "react";

import Grid from "@mui/material/Grid2";
import { Container, Typography } from "@mui/material";

import { Routes, Route } from "react-router-dom";
import { Item, classes } from "./style";

import IntroductionScene from "./scenes/introduction";
import QuizScene from "./scenes/quiz";
import ResultsScene from "./scenes/results";
import AnimalsScene from "./scenes/animals";

export const QUIZ_LENGTH = 60;

const Quiz = () => {
  return (
    <Item>
      <main className={classes.root}>
        <Routes>
          <Route path={`/`} element={<IntroductionScene />} />
          <Route path={`quiz`} element={<QuizScene />} />
          <Route path={`results`} element={<ResultsScene />} />
          <Route path={`animals`} element={<AnimalsScene />} />
        </Routes>
        <div style={{ flex: 1 }} />
        <div className={classes.banner}>
          <Container className={classes.onet}>
            <Grid container justifyContent="center" alignItems="">
              <Grid size={{ xs: 12 }} textAlign="center">
                <Typography variant="h6">
                  This page includes information from the{" "}
                  <a
                    className={classes.onetlink}
                    target="_blank"
                    href="https://www.onetcenter.org/tools.html"
                    rel="noreferrer"
                  >
                    O*NET Career Exploration Tools
                  </a>{" "}
                  by the U.S. Department of Labor, Employment and Training
                  Administration (USDOL/ETA). Used under the{" "}
                  <a
                    className={classes.onetlink}
                    target="_blank"
                    href="https://creativecommons.org/licenses/by-nd/4.0/"
                    rel="noreferrer"
                  >
                    CC BY-ND 4.0
                  </a>{" "}
                  license.{" "}
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </div>
      </main>
    </Item>
  );
};

export default Quiz;
